import React from "react";

export default function GridBg() {
  return <div className="gps-grid-bg" aria-hidden="true" />;
}
